import ChevronIcon from "theme/components/icons/ChevronIcon";
import React from "react";
import TextLink from "theme/components/text/TextLink";
import hideOverlay from "core-web/state/models/Overlay/dispatches/hideOverlays";
import setActiveTopLabel from "core-web/state/models/Header/dispatches/setActiveTopLabel";
import showOverlay from "core-web/state/models/Overlay/dispatches/showOverlay";
import styled from "theme/libs/styled";
import toggleMenu from "core-web/state/models/Header/dispatches/toggleMenu";
import { useSelector } from "react-redux";

const Nav = styled("nav")`
    display: flex;
    align-items: center;

    > *:not(:last-child) {
        margin-right: 24px;
    }

    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    &::before,
    &::after {
        display: block;
        content: "";
        pointer-events: none;
        position: sticky;
        top: 0;
        bottom: 0;
        height: 100%;
        min-height: 1.5rem;
        min-width: 20px;
        pointer-events: none;
        z-index: 1;
    }

    &::before {
        left: 0;
        background: ${({ theme }) => `linear-gradient(90deg, ${theme.colors.white} 0%, ${theme.colors.white}00 100%)`};
    }

    &::after {
        right: 0;
        background: ${({ theme }) => `linear-gradient(90deg, ${theme.colors.white}00 0%, ${theme.colors.white} 100%)`};
    }
`;

const TopNavigation = () => {
    const primaryNavigation = useSelector(({ header }) => header?.data?.menu?.primary_navigation) || {};
    const { activeNavTopLabel } = useSelector(({ header }) => header.states);

    const handleClick = (e, text, url, subMenu, viewAllLabel) => {
        if (!!subMenu.length && !(activeNavTopLabel === text)) {
            e.preventDefault();
            toggleMenu(true);
            setActiveTopLabel(text);

            showOverlay("nav_desktop", {
                parentTitle: text,
                parentUrl: url,
                subMenu,
                viewAllLabel,
            });
        } else {
            toggleMenu(false);
            hideOverlay();
            setActiveTopLabel(null);
        }
    };

    return (
        <Nav>
            {!!primaryNavigation?.length &&
                primaryNavigation.map(
                    ({ header_link: { text, url }, sub_menu: subMenu, view_all_label: viewAllLabel }) => (
                        <TextLink
                            key={`${text}-${url}`}
                            to={!subMenu && url}
                            isActive={activeNavTopLabel === text}
                            textStyles="Myriad Pro/14-100"
                            textWrap="nowrap"
                            onClick={(e) => handleClick(e, text, url, subMenu, viewAllLabel)}
                            gap="4px"
                        >
                            {text}
                            {!!subMenu && <ChevronIcon height="0.8em" width="auto" color="currentColor" />}
                        </TextLink>
                    ),
                )}
        </Nav>
    );
};

// export default React.memo(TopNavigation); //TODO: use memo?
export default TopNavigation;
